// src/components/StickyFooter.jsx
export default function StickyFooter() {
  return (
    <div
      style={{
        position: "fixed",
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 50,
        padding: "10px 14px",
        background: "rgba(255,255,255,0.92)",
        borderTop: "1px solid rgba(0,0,0,0.08)",
        backdropFilter: "blur(8px)",
        WebkitBackdropFilter: "blur(8px)",
        fontSize: 12,
        color: "#667085",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
        <a href="/terms" style={{ color: "#667085", textDecoration: "none" }}>
          Terms
        </a>
        <span style={{ opacity: 0.6 }}>·</span>
        <a href="/privacy" style={{ color: "#667085", textDecoration: "none" }}>
          Privacy Policy
        </a>
      </div>
    </div>
  );
}
